import type { ChangeRequestReason } from '@contracts/changeRequest/ChangeRequestContract';

export class ChangeRequest {
  public readonly id: string;
  public readonly orderId: string;
  public readonly reason: ChangeRequestReason;
  public readonly form: Record<string, unknown>;
  public readonly dirtyFields: string[];
  public readonly requestedAt: Date;

  constructor({
    id,
    orderId,
    reason,
    form,
    dirtyFields,
    requestedAt,
  }: {
    id: string;
    orderId: string;
    reason: ChangeRequestReason;
    form: Record<string, unknown>;
    dirtyFields: string[];
    requestedAt: Date;
  }) {
    this.id = id;
    this.orderId = orderId;
    this.reason = reason;
    this.form = form;
    this.dirtyFields = dirtyFields;
    this.requestedAt = requestedAt;
  }

  isAffected(field: string) {
    return this.dirtyFields.includes(field);
  }

  isAffectedForPermit(field: string, permitApplicationId: string): boolean {
    const tripFieldPath = `trips.${permitApplicationId}.${field}`;
    return this.isAffected(field) || this.isAffected(tripFieldPath);
  }
}
